import React from "react";
import PipelineRedesign from "../redesign/PipelineRedesign";

const Pipeline = () => {
  return <PipelineRedesign />;
};

export default Pipeline;
